import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DialogProps } from "./useDialogs";

function RestoreProcessingDialog({
  payload,
  open,
  onClose,
}: DialogProps<{ reset: Function }>) {
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{"Supprimer les modifications?"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Êtes-vous sûr de vouloir supprimer vos modfications?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button
          onClick={() => {
            payload.reset();
            onClose();
          }}
          autoFocus
        >
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RestoreProcessingDialog;
